var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading === true || _vm.error.message.length)?_c('LoadingBar',{attrs:{"error":_vm.error.message}}):_c('Page',{attrs:{"title":"Billing Accounts - Manage"}},[_c('BillingAccounts')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }